import { Timestamp } from '@firebase/firestore-types';

export type UserRole = 'admin' | 'user';
export type UserTier = 'free' | 'paid';

export interface UserPrivilegesDefaultValue {
    isPaidCustomer: boolean;
    role: UserRole;
    tier: UserTier;
}

export const userPrivilegesDefaultValue: UserPrivilegesDefaultValue = {
    isPaidCustomer: false,
    role: 'user',
    tier: 'free',
};

export interface UserPrivileges extends UserPrivilegesDefaultValue {
    createdAt: Timestamp;
    email: string;
    featureFlags?: string[];
    skipEmailVerification?: boolean;
    skipMfaEnrollment?: boolean;
    skipSessionVerification?: boolean;
    subscriptionEndDate?: number;
    subscriptionStartDate?: number;
    trialEndDate?: number;
}
